import React from 'react';

// Renders schema.org structured data. Accepts one object or an array of objects.
const JsonLd = ({ data }) => {
  const items = Array.isArray(data) ? data : [data];
  return items.map((item, index) => (
    <script
      key={index}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(item).replace(/</g, '\\u003c') }}
    />
  ));
};

export default JsonLd;
